import dayjs from 'dayjs';
import { ChangeEventHandler, FC, useCallback, useRef, useState } from 'react';

import './mm-yy.scss';

var customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

const ExpirationDate: FC<{
  date?: Date | number | string | null;
  label?: string;
  setDate: (date?: number) => void;
  disabled?: boolean;
  required?: boolean;
}> = ({ date, label, setDate, disabled, required }) => {
  const [input, setInput] = useState(!date ? '' : dayjs(date).format('MM/YY'));

  const labelRef = useRef<HTMLLabelElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleReset = useCallback(() => {
    setInput('');
    inputRef.current?.setCustomValidity('');
    setDate(undefined);
  }, [setDate, setInput]);

  const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    e => {
      if (!e.target.value) {
        return handleReset();
      }

      const formatValue = e.target.value
        .replace(/^([0-9]{1,2}\/?[0-9]{0,2})?.*/, '$1') /* M(M)(/)(Y)(Y)... -> M(M)(/)(Y)(Y) */
        .replace(/^([0-9]{2})\/?([0-9]{1,2})/, '$1/$2') /*        MM(/)Y(Y) -> MM/Y(Y)      */
        .replace(/^([0-9]{1})\/([0-9]{1,2})/, '0$1/$2'); /*          M/Y(Y) -> 0M/Y(Y)     */

      setInput(formatValue);
      const dayjsValue = dayjs(formatValue, 'MM/YY', true);

      if (dayjsValue.isValid()) {
        e.target.setCustomValidity('');
        setDate(dayjsValue.valueOf());
      } else {
        e.target.setCustomValidity('Invalid date (expected MM/YY)');
      }
    },
    [handleReset, setDate, setInput]
  );

  return (
    <div id="mm-yy" className="w-100">
      <input
        type="text"
        inputMode="numeric"
        placeholder="MM/YY"
        className={`w-100 ${!input.length ? 'blank' : ''}`}
        id={label}
        value={input}
        onChange={handleChange}
        ref={inputRef}
        disabled={disabled}
        required={required}
      />
      {!!label && (
        <label htmlFor={label} ref={labelRef}>
          {label}
          {required && ' *'}
        </label>
      )}
      <button className="btn-back clear-btn" type="button" onClick={handleReset} tabIndex={-1}>
        <span className="material-icons icon-large">close</span>
      </button>
    </div>
  );
};

export default ExpirationDate;
